import { useFiltersParam as useFiltersParamBase } from '../../../../hooks/search-params/use-filters-param';
import { PAYMENTS_FILTER_FIELDS } from '../payments-page-utils/payment-filter-fields';
import type { FilterLineType } from '../../../../components/new-design/vyTableFilter';

export function useFiltersParam() {
  return useFiltersParamBase<FilterLineType>('paymentFilters', PAYMENTS_FILTER_FIELDS);
}
